import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ISharedDeliveryFieldsFragment = {
  projectFromId?: any | null
  projectToId?: any | null
  id?: any | null
  deliveryId?: any | null
  companyName?: string | null
  startDate?: any | null
  endDate?: any | null
  driverPhoneNumbers?: Array<string | null> | null
  status?: Types.DeliveryStatus | null
  tenantName?: string | null
  truckNumber?: string | null
  projectUrl?: string | null
  bookingId?: string | null
  locationsFrom?: Array<{
    locationName?: string | null
    locationUrl?: string | null
  } | null> | null
  locationsTo?: Array<{
    locationName?: string | null
    locationUrl?: string | null
  } | null> | null
  responsible?: {
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    email?: string | null
  } | null
}

export type IGetSharedDeliveriesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetSharedDeliveriesQuery = {
  getSharedDeliveriesByProjectToId?: Array<{
    projectFromId?: any | null
    projectToId?: any | null
    id?: any | null
    deliveryId?: any | null
    companyName?: string | null
    startDate?: any | null
    endDate?: any | null
    driverPhoneNumbers?: Array<string | null> | null
    status?: Types.DeliveryStatus | null
    tenantName?: string | null
    truckNumber?: string | null
    projectUrl?: string | null
    bookingId?: string | null
    locationsFrom?: Array<{
      locationName?: string | null
      locationUrl?: string | null
    } | null> | null
    locationsTo?: Array<{
      locationName?: string | null
      locationUrl?: string | null
    } | null> | null
    responsible?: {
      firstName?: string | null
      lastName?: string | null
      phoneNumber?: string | null
      email?: string | null
    } | null
  } | null> | null
}

export type IListenToSharedDeliveriesSubscriptionVariables = Types.Exact<{
  projectToId?: Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IListenToSharedDeliveriesSubscription = {
  sharedDelivery?: {
    id?: any | null
    item?: {
      projectFromId?: any | null
      projectToId?: any | null
      id?: any | null
      deliveryId?: any | null
      companyName?: string | null
      startDate?: any | null
      endDate?: any | null
      driverPhoneNumbers?: Array<string | null> | null
      status?: Types.DeliveryStatus | null
      tenantName?: string | null
      truckNumber?: string | null
      projectUrl?: string | null
      bookingId?: string | null
      locationsFrom?: Array<{
        locationName?: string | null
        locationUrl?: string | null
      } | null> | null
      locationsTo?: Array<{
        locationName?: string | null
        locationUrl?: string | null
      } | null> | null
      responsible?: {
        firstName?: string | null
        lastName?: string | null
        phoneNumber?: string | null
        email?: string | null
      } | null
    } | null
  } | null
}

export const SharedDeliveryFieldsFragmentDoc = gql`
  fragment SharedDeliveryFields on SharedDelivery {
    projectFromId
    projectToId
    id
    deliveryId
    companyName
    startDate
    endDate
    driverPhoneNumbers
    status
    tenantName
    truckNumber
    locationsFrom {
      locationName
      locationUrl
    }
    locationsTo {
      locationName
      locationUrl
    }
    projectUrl
    bookingId
    responsible {
      firstName
      lastName
      phoneNumber
      email
    }
  }
`
export const GetSharedDeliveriesDocument = gql`
  query GetSharedDeliveries($projectId: ObjectId!) {
    getSharedDeliveriesByProjectToId(projectId: $projectId) {
      ...SharedDeliveryFields
    }
  }
  ${SharedDeliveryFieldsFragmentDoc}
`

/**
 * __useGetSharedDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetSharedDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedDeliveriesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSharedDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetSharedDeliveriesQuery,
    IGetSharedDeliveriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetSharedDeliveriesQuery,
    IGetSharedDeliveriesQueryVariables
  >(GetSharedDeliveriesDocument, options)
}
export function useGetSharedDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSharedDeliveriesQuery,
    IGetSharedDeliveriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSharedDeliveriesQuery,
    IGetSharedDeliveriesQueryVariables
  >(GetSharedDeliveriesDocument, options)
}
export type GetSharedDeliveriesQueryHookResult = ReturnType<
  typeof useGetSharedDeliveriesQuery
>
export type GetSharedDeliveriesLazyQueryHookResult = ReturnType<
  typeof useGetSharedDeliveriesLazyQuery
>
export type GetSharedDeliveriesQueryResult = Apollo.QueryResult<
  IGetSharedDeliveriesQuery,
  IGetSharedDeliveriesQueryVariables
>
export const ListenToSharedDeliveriesDocument = gql`
  subscription listenToSharedDeliveries($projectToId: ObjectId) {
    sharedDelivery(projectToId: $projectToId) {
      id
      item {
        ...SharedDeliveryFields
      }
    }
  }
  ${SharedDeliveryFieldsFragmentDoc}
`

/**
 * __useListenToSharedDeliveriesSubscription__
 *
 * To run a query within a React component, call `useListenToSharedDeliveriesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToSharedDeliveriesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToSharedDeliveriesSubscription({
 *   variables: {
 *      projectToId: // value for 'projectToId'
 *   },
 * });
 */
export function useListenToSharedDeliveriesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    IListenToSharedDeliveriesSubscription,
    IListenToSharedDeliveriesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToSharedDeliveriesSubscription,
    IListenToSharedDeliveriesSubscriptionVariables
  >(ListenToSharedDeliveriesDocument, options)
}
export type ListenToSharedDeliveriesSubscriptionHookResult = ReturnType<
  typeof useListenToSharedDeliveriesSubscription
>
export type ListenToSharedDeliveriesSubscriptionResult =
  Apollo.SubscriptionResult<IListenToSharedDeliveriesSubscription>
